import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import ApiClient from "#/redux/api/ApiClient";

// prilagodi path

const initialState = {
  list: [],
  isLoading: false,
  error: null,
};

export const fetchCountryCodeList = createAsyncThunk(
  "countryaCodeList/fetchAll",
  async (_, { rejectWithValue }) => {
    // eslint-disable-next-line no-console
    console.warn("Deprecated, migrate to LookupTable hooks and components");

    try {
      const res = await ApiClient.get("/api/sif/drzava");
      return res.data;
    } catch (e) {
      return rejectWithValue(
        e?.response?.data ?? e?.message ?? "fetchCountryCodeList failed"
      );
    }
  }
);

const countryCodeListSlice = createSlice({
  name: "countryaCodeList",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCountryCodeList.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchCountryCodeList.fulfilled, (state, action) => {
        state.isLoading = false;
        state.list = action.payload;
      })
      .addCase(fetchCountryCodeList.rejected, (state, action) => {
        state.isLoading = false;
        state.error =
          action.payload ?? action.error?.message ?? "Unknown error";
      });
  },
});

export default countryCodeListSlice.reducer;
